import createSpinner from "../../Shared/Functions/createSpinner";
export default /*@ngInject*/ function ($http, $scope, $rootScope, $route, ViewProductImportPageService, $filter, dataService, authenticationService, KPIOverrideDefinitions, KPIGeneratorService, helperService, CustomReportServices, homeDataService, configurationDataService) {

    const vm = this;

    vm.runReport = runReport;
    vm.savedReportsDataSource = [];
    vm.usersByProductStatistics = [];
    vm.companiesByProductStatistics = [];
    vm.listOfCards = [];
    vm.expandNewDashboardSection = expandNewDashboardSection;
    vm.cancelNewDashboard = expandNewDashboardSection;
    vm.createDashboardIsCollapsed = false;
    vm.focusNewDashboardName = false;
    vm.dashboardName = '';
    vm.launchReport = launchReport;
    vm.fusionChartEvents = {};
    vm.launchReportFromTable = launchReportFromTable;
    vm.launchReportFromTile = launchReportFromTile;
    vm.createPartialSavedReportAndNavigate = createPartialSavedReportAndNavigate;
    vm.postCardsToApi = postCardsToApi;
    vm.reloadPackery = reloadPackery;
    vm.cardChangedVisibility = cardChangedVisibility;
    vm.deleteDashboard = deleteDashboard;
    vm.createDashboard = createDashboard;
    vm.dashboardSelected = dashboardSelected;
    vm.setDashboardSettings = setDashboardSettings;
    vm.showLabels = showLabels;
    vm.isLogiEnabled = false;
    vm.accessToken = null;
    vm.embeddedDashboards = [];
    vm.selectedEmbeddedDashboard = null;
    vm.embeddedDashboardSelected = embeddedDashboardSelected;
    vm.embedManagerPromise = null;
    vm.componentInstanceId = null;
    vm.loadingLogi = false;
    vm.setDefaultLogiDashboard = setDefaultLogiDashboard;
    vm.themeId = 'modern';

    function runReport(savedReport) {
        CustomReportServices.loadSavedReport(savedReport);
    }

    vm.$onInit = init;

    async function init() {
        let FF_EmbeddedLogiAnalytics = await configurationDataService.getConfigurationValueByName('FF_EmbeddedLogiAnalytics');
        if (FF_EmbeddedLogiAnalytics.data === 1) {
            vm.isLogiEnabled = true;
        }

        if (!vm.isLogiEnabled) {
            setEvents();
            setFusionChart();

            await setupDashboard();
            await setSavedReportsByUser();
            await setUsersByProductStatistics();
            await setCompaniesByProductStatistics();

            vm.reloadPackery();
            vm.postCardsToApi();
        } else {
            vm.loadingLogi = true;
            let authenticateResponse = await homeDataService.authenticateUser();
            vm.accessToken = authenticateResponse.data.Token;
            vm.embedManagerPromise = window.initComposerEmbedManager({ "initialToken": vm.accessToken });
            await getListOfDashboards();
            await getThemes();
            await setupLogiDashboard();
            vm.loadingLogi = false;
        }
    }

    async function setupLogiDashboard() {
        const componentConfig = {
            "originId": "",
            "dashboardId": vm.selectedEmbeddedDashboard.id,
            "interactivityProfileName": "interactive",
            "interactivityOverrides": {
                "name": "interactive",
                "type": "SYSTEM",
                "overrideVisualInteractivity": true,
                "settings": {
                    "REFRESH": true,
                    "CHANGE_LAYOUT": true,
                    "RENAME": true,
                    "SHARE_FILTER_SETS": true,
                    "DASHBOARD_INTERACTIONS": true,
                    "ADD_TO_FAVORITES": true,
                    "DELETE": true,
                    "FILTER": true,
                    "EXPORT_PNG_PDF": true,
                    "ADD_VISUALS": true,
                    "EXPORT_CONFIGURATION": true,
                    "DASHBOARD_LINKS": true,
                    "SAVE": true,
                    "SAVE_AS": true,
                    "MANAGE_TAGS": false,
                    "DASHBOARD_ALERTS": true,
                    "SHARE_DASHBOARD": true,
                    "SCHEDULE_REPORTS": true,
                    "CREATE_TEXT_SNIPPETS": true,
                    "CREATE_FILTER_SNIPPETS": true,
                    "WIDGET_SETTINGS": true,
                    "COMMENTS": false
                },
                "visualSettings": {
                    "ACTIONS_ACTION": true,
                    "RULERS": true,
                    "ZOOM_ACTION": true,
                    "FILTER_ACTION": true,
                    "COLORS": true,
                    "METRICS": true,
                    "ACTIONS": true,
                    "TREND_ACTION": true,
                    "VISUAL_STYLE": true,
                    "KEYSET_ACTION": true,
                    "KEYSET": true,
                    "COPY": true,
                    "SETTINGS": true,
                    "EXPORT": true,
                    "TIMEBAR_PANEL": true,
                    "DETAILS_ACTION": true,
                    "MAXIMIZE": true,
                    "LINK_ACTION": true,
                    "FILTER": true,
                    "REMOVE": true,
                    "GROUPING": true,
                    "RENAME": true,
                    "SORT": true,
                    "TIMEBAR_FIELD": true,
                    "CONDITIONAL_FORMATTING": true,
                    "INFO": true
                }
            },
            "theme": vm.themeId,
            "editor": { "placement": "modals" },
            "header": {
                "showActions": false,
                "showTitle": false,
                "visible": true
            }
        };

        const createEmbedComponent = (embedManager, config, containerElementId = 'widget-holder') => {
            if (vm.componentInstanceId) {
                embedManager.removeComponent(vm.componentInstanceId);
            }

            return embedManager.createComponent("dashboard", config).then(component => {
                vm.componentInstanceId = component.componentInstanceId;
                component.render(document.getElementById(containerElementId), { width: "100%", height: "100%" });
            });
        };

        vm.embedManagerPromise.then(embedManager => {
            //debugger;
            createEmbedComponent(embedManager, componentConfig, 'widget-holder');
        });
    }

    async function getThemes() {
        const themesUrl = `${logiUrl}discovery/api/customization/themes`;
        const headers = {
            'Accept': 'application/vnd.composer.v3+json',
            'Content-Type': 'application/vnd.composer.v3+json',
            'Authorization': 'Bearer ' + vm.accessToken
        }
        const response = await fetch(themesUrl, { headers });
        const data = await response.json();

        if (data.content) {
            vm.themeId = data.content.filter(d => d.name === 'Delinea')[0].id;
        }
    }

    async function getListOfDashboards() {
        const dashboardsListUrl = `${logiUrl}discovery/api/dashboards`;
        const headers = {
            'Accept': 'application/vnd.composer.v3+json',
            'Content-Type': 'application/vnd.composer.v3+json',
            'Authorization': 'Bearer ' + vm.accessToken
        }
        const response = await fetch(dashboardsListUrl, { headers });
        const data = await response.json();  
        vm.embeddedDashboards = data.content;
        if (vm.embeddedDashboards) {
            let fastpathDefaultDashboard = vm.embeddedDashboards.filter(d => d.name === 'Fastpath Default Dashboard');
            let logiDefaultDashboard = await homeDataService.getDefaultLogiDashboardUserPreference();
            vm.logiDefaultDashboardUserPreference = logiDefaultDashboard;
            if (logiDefaultDashboard) {
                let matchingDashboard = vm.embeddedDashboards.find(db => db.id === logiDefaultDashboard);
                if (matchingDashboard) {
                    vm.selectedEmbeddedDashboard = matchingDashboard;
                }
                else {
                    vm.selectedEmbeddedDashboard = fastpathDefaultDashboard[0];
                    //if this dashboard no longer exists, clear the user preference
                    await homeDataService.setDefaultLogiDashboard({ Name: "LogiDefaultDashboard", Value: fastpathDefaultDashboard[0].id });
                    vm.logiDefaultDashboardUserPreference = await homeDataService.getDefaultLogiDashboardUserPreference();
                }
            }
            else {
                vm.selectedEmbeddedDashboard = fastpathDefaultDashboard[0];
            }

            showSetDefaultDashboardButton();
        } 
    }

    function showSetDefaultDashboardButton() {
        if (!vm.embeddedDashboards || vm.embeddedDashboards.length <= 1) {
            vm.showSetDefaultButton = false;
            return;
        }

        let logiDefaultDashboard = vm.logiDefaultDashboardUserPreference;
        if (vm.selectedEmbeddedDashboard?.name === "Fastpath Default Dashboard" && !logiDefaultDashboard) {
            vm.showSetDefaultButton = false;
            return;
        }

        vm.showSetDefaultButton = logiDefaultDashboard !== vm.selectedEmbeddedDashboard.id;
    }

    async function setDefaultLogiDashboard() {
        vm.savingDefaultLogiDashboard = new createSpinner();
        try {
            await homeDataService.setDefaultLogiDashboard({ Name: "LogiDefaultDashboard", Value: vm.selectedEmbeddedDashboard.id });

            vm.logiDefaultDashboardUserPreference = await homeDataService.getDefaultLogiDashboardUserPreference();
            showSetDefaultDashboardButton();
            await helperService.successfulSaveButton(vm.savingDefaultLogiDashboard);
        } catch {
            vm.savingDefaultLogiDashboard.loadingValue = false;
        }
    }

    async function embeddedDashboardSelected() {
        await setupLogiDashboard();
        showSetDefaultDashboardButton();
    }

    function setEvents() {
        $scope.$on('$routeChangeStart', () => {
            delete $rootScope.packery;

            if (vm.listOfCards) {
                vm.listOfCards.forEach(card => {
                    if (card.ChartId) {
                        var fusionChart = FusionCharts.items[card.ChartId];
                        if (fusionChart) {
                            fusionChart.dispose();
                        }
                    }
                });
            }
        });

        $rootScope.$on('packery-card-changed-position', (event, args) => {
            vm.listOfCards.forEach(row => {
                args.forEach(card => {
                    if (card.cardId === row.Id) {
                        row.Ordinal = card.cardIndex;
                    }
                });
            });

            vm.postCardsToApi();
            vm.reloadPackery();
        });
    }

    function setFusionChart() {
        vm.fusionChartEvents = {
            beforeRender: () => {
                $rootScope.packery.layout();
            },
            renderComplete: () => {
                $rootScope.packery.layout();
            },
            dataPlotClick: (ev, props) => {
                var objectId = ev.sender.args.dataSource.reportObjectId;

                if (ev.sender.args.type === 'stackedcolumn2d') {
                    let filters = [
                        { 'Label': ev.sender.args.dataSource.reportCategory, 'Value': props.categoryLabel },
                        { 'Label': ev.sender.args.dataSource.reportSeries, 'Value': props.datasetName }
                    ]
                    vm.createPartialSavedReportAndNavigate(filters, objectId);
                } else {
                    var field = ev.sender.args.dataSource.reportField;
                    var row = ev.sender.args.dataSource.data[props.index];

                    vm.createPartialSavedReportAndNavigate([{ 'Label': field, 'Value': row.Label }], objectId);
                }
            }
        };
    }

    async function setSavedReportsByUser() {
        const currentUser = await authenticationService.getUser();
        let { data } = await dataService.getSavedReportsByUser(currentUser.userId);

        vm.savedReportsDataSource = $filter('orderBy')(data, 'Name');
    }

    async function setUsersByProductStatistics() {
        const { data } = await homeDataService.getUserStatistics();

        vm.usersByProductStatistics = data;
    }

    async function setCompaniesByProductStatistics() {
        const { data } = await homeDataService.getCompanyStatistics();

        vm.companiesByProductStatistics = data;
    }

    async function setupDashboard() {
        let response = await homeDataService.getDashboards();
        
        response.data = $filter('orderBy')(response.data, 'Name');

        vm.listOfDashboards = response.data;

        var defaultDashboard = $rootScope.UserPreferences['DefaultDashboard'];

        var selectedDashboard = null;

        if (defaultDashboard) {
            selectedDashboard = vm.listOfDashboards.filter(e => e.Id.toLowerCase() === defaultDashboard.toLowerCase())[0];
        }

        if (selectedDashboard) {
            vm.selectedDashboard = vm.listOfDashboards.filter(e => e.Id === selectedDashboard.Id)[0];
        } else {
            vm.selectedDashboard = response.data[0];
        }

        response = await homeDataService.getCards();

        response.data = $filter('filter')(response.data, { HasAccess: 'true' });
        var listOfCards = response.data;

        listOfCards = $filter('orderBy')(listOfCards, 'Ordinal');


        //Card Defaults
        listOfCards.forEach(card => {
            card.Icon = 'icons8-combo-chart';
        });

        response = await homeDataService.getCharts();

        response.data.forEach(row => {

            var selectedCard = null;

            listOfCards.forEach(card => {
                if (card.ChartId === row.Id) {
                    selectedCard = card;
                }
            });

            if (selectedCard) {
                switch (row.ChartType) {
                    case 'table':
                        selectedCard.Chart = KPIGeneratorService.createGenericTableChart(row);
                        break;
                    case 'doughnut2d':
                        selectedCard.Chart = KPIGeneratorService.createGenericDoughnutChart(row);
                        break;
                    case 'column2d':
                        selectedCard.Chart = KPIGeneratorService.createGenericColumnChart(row);
                        break;
                    case 'tile':
                        selectedCard.Chart = KPIGeneratorService.createGenericTile(row);
                        break;
                    case 'stackedcolumn2d':
                        selectedCard.Chart = KPIGeneratorService.createGenericStackedColumnChart(row);
                        break;
                    default:
                        selectedCard.Chart = KPIGeneratorService.createGenericColumnChart(row);
                        break;
                }
            }

            listOfCards.forEach(card => {
                KPIOverrideDefinitions.overrideById(card);
            });
        });


        vm.listOfCards = listOfCards;
        vm.setDashboardSettings();

        vm.listOfCards.forEach(card => {

            if (card.Visible && card.Chart) {
                homeDataService.getChartByCard(card.Chart.APIUrl).then(response => {
                    if (card.Chart.CardType === 'tile') {
                        card.Chart = KPIGeneratorService.setTileChartValues(card.Chart, response.data);
                    }

                    if (card.Chart.CardType === 'stackedcolumn2d') {
                        card.Chart.DataSource.dataset = response.data.DataSet;
                        card.Chart.DataSource.categories = response.data.Categories;
                        response.data = KPIGeneratorService.setPropertiesForStackedChart(response.data);
                    }
                    else {
                        card.Chart.DataSource.data = response.data;
                        response.data = KPIGeneratorService.setPropertiesForChart(response.data);
                    }
                });
            }
        });
    }

    function expandNewDashboardSection() {
        vm.createDashboardIsCollapsed = !vm.createDashboardIsCollapsed;
        vm.focusNewDashboardName = true;
    }

    function launchReport(objectId) {
        ViewProductImportPageService.launchReportByObjectId(objectId);
    }

    function launchReportFromTable(label, card) {
        var field = card.Chart.DataSource.reportField;
        vm.createPartialSavedReportAndNavigate([{ 'Label': field, 'Value': label }], card.Chart.ObjectId);
    }

    function launchReportFromTile(card) {
        vm.createPartialSavedReportAndNavigate([], card.Chart.ObjectId);
    }

    function createPartialSavedReportAndNavigate(filters, objectId) {
        $rootScope.loadedSavedReport = KPIGeneratorService.createSavedReportStub(filters, objectId);
        ViewProductImportPageService.launchReportByObjectId(objectId);
    }

    async function postCardsToApi() {
        var postData = { 'Cards': [] };

        vm.listOfCards.forEach(card => {
            if (vm.selectedDashboard.Id === card.DashboardId) {

                var item = {
                    Id: card.Id,
                    Ordinal: card.Ordinal,
                    Visible: card.Visible,
                    Expanded: card.Expanded,
                    DashboardId: card.DashboardId
                };

                postData.Cards.push(item);
            }
        });
        if (postData.Cards.length > 0) {
            await homeDataService.createCard(postData);
        }
    }

    function reloadPackery() {
        if ($rootScope.packery) {
            $rootScope.packery.layout();
        }
    }

    function cardChangedVisibility(card) {
        if (card.Visible) {
            if (card.DashboardId === "00000000-0000-0000-0000-000000000000") {
                card.DashboardId = vm.selectedDashboard.Id;
            }

            homeDataService.getChartByCard(card.Chart.APIUrl).then(response => {
                if (card.Chart.CardType === 'tile') {
                    card.Chart = KPIGeneratorService.setTileChartValues(card.Chart, response.data);
                }
                if (card.Chart.CardType === 'stackedcolumn2d') {
                    card.Chart.DataSource.dataset = response.data.DataSet;
                    card.Chart.DataSource.categories = response.data.Categories;
                    response.data = KPIGeneratorService.setPropertiesForStackedChart(response.data);
                }
                else {
                    card.Chart.DataSource.data = response.data;
                    response.data = KPIGeneratorService.setPropertiesForChart(response.data);
                }

            });
        }
        vm.postCardsToApi();
        vm.reloadPackery();
    }

    async function deleteDashboard() {
        try {
            await homeDataService.deleteDashboard(vm.selectedDashboard.Id);

            $route.reload();
        } catch (error) {
            helperService.showErrorMessage(error.data);
        }
    }

    async function createDashboard() {
        let postData = {
            "Name": vm.dashboardName
        },
            response;

        try {
            response = await homeDataService.createDashboard(postData);

            vm.selectedDashboard = { "Id": response.data };
            dashboardSelected();
        } catch (error) {
            helperService.showErrorMessage(error.data);
        }
    }

    async function dashboardSelected() {
        let data = {
            Name: "DefaultDashboard",
            Value: vm.selectedDashboard.Id
        };

        try {
            await homeDataService.getDashboard(data)
            $rootScope.UserPreferences['DefaultDashboard'] = vm.selectedDashboard.Id;
            $route.reload();
        } catch {
            return;
        }
    }

    function setDashboardSettings() {
        vm.listOfCards.forEach(card => {
            if (!vm.selectedDashboard.Cards.some(c => c.Id === card.Id)) {
                card.Visible = false;
                card.Ordinal = 0;
                return;
            }
            vm.selectedDashboard.Cards.forEach(selectedCard => {
                if (card.Id === selectedCard.Id) {
                    card.Expanded = selectedCard.Expanded;
                    card.Ordinal = selectedCard.Ordinal;
                    card.Visible = selectedCard.Visible;
                    card.DashboardId = selectedCard.DashboardId;
                }
            });
        });
        vm.listOfCards = $filter('orderBy')(vm.listOfCards, 'Ordinal');
    }


    function showLabels(dataSource, showlabels, valuesToFlip) {
        if (showlabels) {
            valuesToFlip.forEach(row => {
                dataSource.chart[row] = "1";
            });
        } else {
            valuesToFlip.forEach(row => {
                dataSource.chart[row] = "0";
            });
        }
    }

}